export default function eventsWidget() {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;
  const $widget = $(`#${widgetName}`);

  $widget.append('<div class="multiFeatureContent"></div>');

  $widget.MultiScheduleFeature({
    multiFeatureLoaded: function (data) {
      if (!data.length) {
        $widget.remove();
        $('body').addClass('no-events-loaded');
        return;
      }

      customAutoEventFormat(data);
      $('.all-events-btn')
        .addClass('button')
        .appendTo($widget)
        .wrap('<div class="btn-container"></div>');
    },
    scriptPath: widgetOpts.scriptPath,
    detectIpad: IPADDETECTED,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    link: ['all'],
    allEventsLink: true,
    isResponsive: false,
    lazyLoadImages: false,
    maxItemsVisible: 5,
    allEventsLinkText: 'view full calendar',
    attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons',
    },
  });

  // ****************************************************************
  // Helpers
  function customAutoEventFormat(data) {
    $(`#${widgetName} .featureItem`).each(function (i) {
      const $cardEvent = $(this);
      const { Date: widgetDate, Name: widgetName, URL: widgetURL } = data[i];

      const fixedDate = widgetDate.split('-');
      let dateLayout = '';

      if (fixedDate.length === 1) {
        const monthStart = formatDate(fixedDate, 0, 0, 0).substring(0, 3);
        const dayStart = formatDate(fixedDate, 0, 0, 1);
        dateLayout = buildEventDateLayout(monthStart, dayStart);
      } else if (fixedDate.length === 2) {
        const monthStart = formatDate(fixedDate, 0, 0, 0).substring(0, 3);
        const dayStart = formatDate(fixedDate, 0, 0, 1);
        const monthEnd = formatDate(fixedDate, 1, 0, 0).substring(0, 3);
        const dayEnd = formatDate(fixedDate, 1, 0, 1);
        dateLayout = buildEventDateLayout(monthStart, dayStart, monthEnd, dayEnd);
      }

      $cardEvent.empty().append(buildEventInfoLayout(widgetName));

      widgetURL
        ? $cardEvent.attr('href', widgetURL)
        : $cardEvent.addClass('void').removeAttr('href');

      $cardEvent.append(dateLayout);
    });
  }
}

// ****************************************************************
// Helpers (no widget-scope dependencies, kept at module scope)

function buildEventInfoLayout(title) {
  return `
      <div class="arrow"></div>
      <div class="event-info">
        <span class="event-name">${title}</span>
      </div>`;
}

function formatDate(date, slot1, slot2, slot3) {
  return date[slot1].trim().split(',')[slot2].trim().split(' ')[slot3].trim();
}

function buildEventDateLayout(
  eventStartMonth,
  eventStartDay,
  eventEndMonth = null,
  eventEndDay = null,
) {
  if (!eventEndMonth || !eventEndDay) {
    return `
        <div class="event-date">
          <span class="month">${eventStartMonth}</span>
          <span class="day">${eventStartDay}</span>
        </div>`;
  }

  if (eventStartMonth === eventEndMonth) {
    return `
        <div class="event-date double-date">
          <span class="month">${eventStartMonth}</span>
          <span class="day">${eventStartDay}<span class="separator">-</span>${eventEndDay}</span>
        </div>`;
  }

  return `
      <div class="event-date date-range">
        <div class="combo-date">
          <span class="month">${eventStartMonth}</span>
          <span class="day">${eventStartDay}</span>
        </div>
        <span class="separator-month">-</span>
        <div class="combo-date">
          <span class="month">${eventEndMonth}</span>
          <span class="day">${eventEndDay}</span>
        </div>
      </div>`;
}
